export default __webpack_public_path__ + "static/media/step-blue-circle-selected.c91f3751.svg";